export default "__VITE_ASSET__Bt9qDd9w__"